import { render, staticRenderFns } from "./choiceRender.vue?vue&type=template&id=965c8dfe&scoped=true&"
import script from "./choiceRender.vue?vue&type=script&lang=js&"
export * from "./choiceRender.vue?vue&type=script&lang=js&"
import style0 from "./choiceRender.vue?vue&type=style&index=0&id=965c8dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965c8dfe",
  null
  
)

export default component.exports